export var StorageKeys;
(function (StorageKeys) {
    StorageKeys["AccessToken"] = "accessToken";
    StorageKeys["AccessTokenExpirationDate"] = "accessTokenExpirationDate";
    StorageKeys["MerchantId"] = "merchantId";
    StorageKeys["ConnectorId"] = "connectorId";
    StorageKeys["TenantName"] = "tenantName";
    StorageKeys["UserName"] = "userName";
    StorageKeys["Password"] = "password";
    StorageKeys["SelectedLanguage"] = "selectedLanguage";
})(StorageKeys || (StorageKeys = {}));
